/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 *
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Injectable } from '@angular/core';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/throw';

import { AuthResourceHandler, ProtectedService, TokenMode } from './auth-resource-handler';
import { OAuthScopedStorage } from './oauth-scoped-storage';

@Injectable()
export class OAuthHttpInterceptor implements HttpInterceptor {

    private authErrorHandler;

    constructor(
        private authStorage: OAuthScopedStorage,
        private authResourceHandler: AuthResourceHandler
    ) {
        this.authErrorHandler = this.authResourceHandler.getErrorHandler();
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let url = req.url.toLowerCase();

        let protectedService = this.getProtectedServiceForUrl(url);

        if (!protectedService) {
            return next.handle(req);
        }

        let accessToken = this.authStorage.getItem('access_token');

        if (accessToken) {
            if (protectedService.tokenMode === TokenMode.Header) {
                let headers = req.headers.set('Authorization', `Bearer ${accessToken}`);
                req = req.clone({ headers });
            } else if (protectedService.tokenMode === TokenMode.UrlParam) {
                let params = req.params.set('access_token', accessToken);
                req = req.clone({ params } );
            }
        }

        return next.handle(req).catch((err) => {
            if (err.status === 401 || err.status === 402 || err.status === 403) {
                this.authErrorHandler(err);
            }
            if (protectedService.errorHandler) {
                protectedService.errorHandler(err);
            }
            return Observable.throw(err);
        });

    }

    private getProtectedServiceForUrl(url: string): ProtectedService {
        let protectedServices = this.authResourceHandler.getProtectedServices();
        let service = protectedServices.find(service => url.startsWith(service.url));
        return service;
    }

}



// WEBPACK FOOTER //
// ./src/main/services/user/oauth-http-interceptor.ts